import React from "react";

const SupportPage = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Destek</h1>
      <p>
        Herhangi bir sorunuz varsa ya da yardıma ihtiyacınız olursa bizimle iletişime geçebilirsiniz:
      </p>
      <ul style={{ lineHeight: "2" }}>
        <li>
          📧 E-posta:{" "}
          <a href="mailto:ebruipekaktukmak@gmail.com">ebruipekaktukmak@gmail.com</a>
        </li>
      </ul>

      <hr style={{ margin: "2rem 0" }} />

      <h2>Sıkça Sorulan Sorular (SSS)</h2>

      <div style={{ marginTop: "1rem" }}>
        <h4>📱 Uygulamayı nasıl kullanabilirim?</h4>
        <p>
          Ürünleri arayarak ya da barkodlarını okutarak içeriklerini inceleyebilir ve sizin için uygun olup olmadığını öğrenebilirsiniz.
        </p>

        <h4>🔍 Barkod okuma çalışmıyor, ne yapmalıyım?</h4>
        <p>
          Kamera izinlerinin açık olduğundan emin olun. Sorun devam ederse manuel arama yapabilirsiniz.
        </p>

        <h4>📩 Geri bildirim gönderebilir miyim?</h4>
        <p>
          Elbette! Görüş ve önerilerinizi <a href="mailto:ebruipekaktukmak@gmail.com">ebruipekaktukmak@gmail.com</a> adresine iletebilirsiniz.
        </p>
      </div>
    </div>
  );
};

export default SupportPage;
